
import DashboardLayout from "@/components/DashboardLayout";
import CurrencySelector from "@/components/CurrencySelector";
import ProductsMainContent from "@/components/ProductsMainContent";
import SharedPageHeader from "@/components/SharedPageHeader";
import DemoBanner from "@/components/DemoBanner";
import { useEtsyStore } from "@/hooks/useEtsyStore";
import { useSubscriptionStatus } from "@/hooks/useSubscriptionStatus";

const Products = () => {
  const {
    isConnected,
    products,
    orders,
    isFetchingProducts,
    checkConnection,
  } = useEtsyStore();

  const { hasActiveSubscription } = useSubscriptionStatus();

  // Check if all products have 0 sales (indicating orders haven't been synced)
  const hasOrderData = products.some(product => (product.salesCount || 0) > 0);
  const needsOrderSync = products.length > 0 && !hasOrderData && hasActiveSubscription;

  const handleConnectionChange = async (connected: boolean) => {
    if (!connected) {
      await checkConnection(true); // Force refresh
    }
  };

  return (
    <DashboardLayout>
      <SharedPageHeader
        title="Products"
        description="Manage your Etsy product inventory."
        feature="product management"
        isConnected={isConnected}
        onConnectionChange={handleConnectionChange}
      >
        {!hasActiveSubscription && (
          <DemoBanner className="mb-6" />
        )}

        <ProductsMainContent 
          products={products}
          isLoading={isFetchingProducts}
          isConnected={isConnected}
          needsOrderSync={needsOrderSync}
        />
        
        <CurrencySelector />
      </SharedPageHeader>
    </DashboardLayout>
  );
};

export default Products;
